import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { environment } from '@meplis/environments';
import { HttpClient } from '@angular/common/http';
import { PaginationOptions } from '@meplis/common';
import { Observable } from 'rxjs';
import { Notification } from '../../common/models/notification/notification';

@Injectable({
  providedIn: 'root',
})
export class ApiNotificationsService extends ApiBaseService {
  protected override apiBaseUrl: string = environment.notificationsV2;
  protected override routePath: string = 'notifications';

  constructor(private _httpClient: HttpClient) {
    super(_httpClient);
  }

  public getNotifications(
    paginationOptions: PaginationOptions
  ): Observable<Notification[]> {
    const path = ``;

    const params = {};

    const options = paginationOptions as unknown as any;
    Object.keys(options).forEach((key: string) => {
      if (
        options[key] !== undefined &&
        options[key] !== null &&
        options[key] !== ''
      ) {
        Object.assign(params, { [key]: options[key] });
      }
    });
    return super.getObservable<Notification[]>(path, { params });
  }

  public registerNotificationToken(
    token: string,
    type: 'WEB' | 'ANDROID' | 'IOS'
  ): Observable<void> {
    const path = `push-notifications`;

    const params = {
      identifier: token,
      type,
    };

    return super.postObservable<void>(path, params);
  }

  public readNotication(token: string): Observable<void> {
    const path = `${token}/read`;
    return super.postObservable(path);
  }

  public unreadNotication(token: string): Observable<void> {
    const path = `${token}/unread`;
    return super.postObservable(path);
  }

  public readAllNotifications(): Observable<void> {
    const path = `all/read`;
    return super.postObservable(path);
  }
}
